






















































import { Component } from 'vue-property-decorator';
import { noop } from 'vue-class-component/lib/util';
import { Form, FormRules } from '@ss/mtd-vue';

import * as api from '@/api';
import InfoTip from '../../../../components/info-tip.vue';
import AbstractRobot from './AbstractRobot';
import { getTtHost } from '@/utils/business';

interface MosesSetting {
    active: boolean;
    mosesBotId: string;
    mosesBotUrl: string;
    resolutionKnowledgeBaseSwitch?: boolean;
}

@Component({ components: { InfoTip } })
export default class MosesRobot extends AbstractRobot {
    rgId: number | null = null;

    solutionIng: boolean = null;
    formData = { active: null, mosesBotId: null, resolutionKnowledgeBaseSwitch: null };
    mosesSetting: MosesSetting = { active: null, mosesBotId: null, mosesBotUrl: null, resolutionKnowledgeBaseSwitch: null };
    settingFormRules: FormRules = {
        mosesBotId: [{ required: true, message: '不可为空' }]
    };

    async mounted() {
        const { rgId } = this.$route.query;
        this.rgId = parseInt(rgId as string, 10);
        await this._initMosesSetting();
    }

    async getActiveState(): Promise<boolean> {
        await this._pullMosesSetting();
        return !!this.mosesSetting.active;
    }

    async onShow() {
        await this._updateMosesSettingActive(true);
    }

    async onHide() {
        await this._updateMosesSettingActive(false);
    }

    async toggleOpenSolution(toggle) {
        if (toggle == null) {
            return;
        }
        this.solutionIng = true;
        const result = await this._updateMosesSetting({ resolutionKnowledgeBaseSwitch: toggle });
        if (result) {
            this.$mtd.message({ message: toggle ? '启用成功' : '已关闭', type: 'success' });
            this.solutionIng = false;
        } else {
            // 如果提交到后台失败了，那么恢复原来的状态
            this.mosesSetting.resolutionKnowledgeBaseSwitch = !toggle;
            this.solutionIng = false;
        }
    }

    async submitMosesBotId() {
        const valid = await this._validateMosesId();
        if (!valid) return;
        const botId = this.formData.mosesBotId;
        const ttHost = getTtHost();
        const landingPageUrl = `${window.location.protocol}//${ttHost}/ticket/moses-helper?rgId=${this.rgId}`;
        this._updateMosesSetting({
            mosesBotId: botId,
            mosesBotUrl: landingPageUrl,
            resolutionKnowledgeBaseSwitch: this.mosesSetting.resolutionKnowledgeBaseSwitch
        });
    }

    clipboardSuccessHandler() {
        this.$mtd.message({ message: '复制成功', type: 'success' });
    }

    private async _initMosesSetting() {
        await this._pullMosesSetting();
    }

    private async _pullMosesSetting() {
        const res = await api.rgApi.getMosesSetting(this.rgId);
        const { code, message, data } = res;
        if (code === 200) {
            const { active, mosesId, content, resolutionKnowledgeBaseSwitch } = data;
            this.mosesSetting.active = active;
            this.mosesSetting.mosesBotId = mosesId;
            this.mosesSetting.mosesBotUrl = content;
            this.mosesSetting.resolutionKnowledgeBaseSwitch = resolutionKnowledgeBaseSwitch;

            // 初始化
            this.formData = { mosesBotId: mosesId, active, resolutionKnowledgeBaseSwitch };
        } else {
            this.$mtd.message({ message, type: 'error' });
        }
    }

    /**
     * 原有切换摩西机器人对话开启/关闭。
     */
    private async _updateMosesSettingActive(active) {
        if (active == null) {
            return;
        }
        const result = await this._updateMosesSetting({ active });
        if (result) {
            noop();
        } else {
            // 如果提交到后台失败了，那么恢复原来的状态
            this.mosesSetting.active = !active;
        }
    }

    private async _updateMosesSetting(payload: Partial<MosesSetting>) {
        const setting: any = {
            rgId: this.rgId,
            active: payload.active != null ? payload.active : true,
            mosesId: (payload.mosesBotId != null ? payload.mosesBotId : this.mosesSetting.mosesBotId) || '',
            content: (payload.mosesBotUrl != null ? payload.mosesBotUrl : this.mosesSetting.mosesBotUrl) || ''
        };
        if (payload.resolutionKnowledgeBaseSwitch !== undefined) {
            setting.resolutionKnowledgeBaseSwitch = payload.resolutionKnowledgeBaseSwitch != null ? payload.resolutionKnowledgeBaseSwitch : false;
        }

        try {
            const { code, message, data } = await api.rgApi.theMosesSetting(setting);
            if (code === 200) {
                const { content, active, mosesId, resolutionKnowledgeBaseSwitch } = data;
                this.mosesSetting.active = active;
                this.mosesSetting.mosesBotId = mosesId;
                this.mosesSetting.mosesBotUrl = content;
                this.mosesSetting.resolutionKnowledgeBaseSwitch = resolutionKnowledgeBaseSwitch;
                this._pullMosesSetting();
                return true;
            } else {
                this.$mtd.message({ message, type: 'error' });
                return false;
            }
        } catch (e) {
            this.$mtd.message({ message: e || '操作失败', type: 'error' });
            return false;
        }
    }

    private _validateMosesId(): Promise<boolean> {
        return new Promise(resolve => {
            (this.$refs.settingForm as Form)
                .validate(valid => {
                    resolve(valid);
                })
                .catch(e => {
                    resolve(false);
                });
        });
    }
}
